var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeart48Line = function SvgIconHeart48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.003 37.432a5.232 5.232 0 0 1-3.75-1.56c-2.36-2.35-7.93-7.94-8.86-8.9-2.81-2.9-3.73-6.23-2.66-9.64a9.24 9.24 0 0 1 15.27-4 9.238 9.238 0 0 1 15.27 4c1.06 3.41.14 6.74-2.66 9.64-.82.84-5.27 5.31-8.87 8.9a5.232 5.232 0 0 1-3.74 1.56Zm-6.42-23.25a7.27 7.27 0 0 0-.93.07 5.89 5.89 0 0 0-4.68 4.09c-.69 2.21-.08 4.26 1.86 6.26.94 1 7 7 8.83 8.87a1.93 1.93 0 0 0 2.68 0c5.06-5.07 8.2-8.22 8.82-8.87 1.94-2 2.55-4 1.86-6.26a5.85 5.85 0 0 0-10.58-1.38 1.7 1.7 0 0 1-2.88 0 5.83 5.83 0 0 0-4.98-2.78Z",
    fill: "current"
  })));
};
export default SvgIconHeart48Line;